import { createFileRoute, redirect } from '@tanstack/react-router';
import { AppLayout } from '@/components/layout/app.layout';

export const Route = createFileRoute('/_app')({
  component: AppLayout,
  beforeLoad: ({ context: { auth } }) => {
    if (!auth.isAuthenticated) {
      return redirect({ to: '/sign-in' });
    }

    if (auth.user?.needToChangePassword) {
      return redirect({ to: '/change-password' });
    }
  },
});
